import {
  getItemFromCollection,
} from "directus/src/operations";
import { apiRoot } from "services/src/config";

export async function fetchFolderForDrive({ id }) {
  try {
    const query = {
      fields: ["id", "folder_id"],
    };
    const response = await getItemFromCollection("integrations_drive", id, query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function addFolderAccess(data) {
  try {
    const response = await apiRoot.post(
      "drive/folder/add_access",
      data,
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function removeFolderAccess({ folder_id, employee }) {
  try {
    const response = await apiRoot.delete(
      `drive/folder/remove_access?folder_id=${folder_id}&employee=${employee}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
